<template>
    <div v-if="stock_detail && formater">
        <v-sheet class="hidden-print" style="margin-top: 80px" />
        <OnePiecePrint :formater="formater" :data="stock_detail" />
    </div>
</template>
<script>
import { mapState } from "vuex";
import StockDetails from "@/api/stock_details";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
    components: {
        OnePiecePrint,
    },
    computed: {
        // 使用对象展开运算符将此对象混入到外部对象中
        ...mapState(["settings"]),
    },
    data: () => ({
        formater: {
            "page_header_left": [],
            "title": {
                "fields": [
                    "stock_batch_code"
                ],
                "formater": "批次详情({0})"
            },
            "headers": [
                [
                    {
                        "field": "stock_in_order_code",
                        "display_text": "入库单号"
                    },
                    {
                        "field": "stock_batch_code",
                        "display_text": "批次号"
                    },
                    {
                        "field": "created",
                        "display_text": "入库时间"
                    }
                ],
                [
                    {
                        "field": "stock_name",
                        "display_text": "仓库"
                    },
                    {
                        "field": "created_user_name",
                        "display_text": "创建者"
                    },
                    {
                        "field": "stock_in_order.created",
                        "display_text": "创建时间"
                    }
                ]
            ],
            "detail_key": "stock_details",
            "columns": [
                {
                    "field": "material_name",
                    "display_text": "商品名称"
                },
                {
                    "field": "material_code",
                    "display_text": "商品编码"
                },
                {
                    "field": "standard_name",
                    "display_text": "规格"
                },
                {
                    "field": "unit",
                    "display_text": "单位"
                },
                {
                    "field": "price",
                    "display_text": "单价",
                    "class": "text-center",
                    "format": "money"
                },
                {
                    "field": "stock_first",
                    "display_text": "入库量",
                    "class": "text-center"
                },
                {
                    "field": "stock_current",
                    "display_text": "剩余库存",
                    "class": "text-center"
                },
                {
                    "field": "total",
                    "display_text": "小计",
                    "class": "text-center",
                    "format": "money"
                },
                {
                    "field": "production_date",
                    "display_text": "生产日期"
                },
                {
                    "field": "expired_date",
                    "display_text": "过期日期"
                },
                {
                    "field": "is_expired",
                    "display_text": "过期状态"
                },
                {
                    "field": "prohibit_flg",
                    "display_text": "冻结状态"
                }
            ],
            "sum_columns": [],
            "footers": [],
            "settings": {
                "table_head_repetitive": 1,
                "table_idx": 1,
                "hide_page_conter": 0,
                "hide_page_counter": 0
            }
        },
        stock_detail: {}
    }),

    mounted() {
        // 批次明细商品生产及过期日期设置
        if (this.settings.product_date_setting == 0) {
            let newColumns = [];
            this.formater.columns.forEach((column) => {
                if (column['display_text'] != "生产日期" && column['display_text'] != "过期日期" && column['display_text'] != "过期状态") {
                    newColumns.push(column)
                }
            });
            this.formater['columns'] = newColumns;
        }

        //获取单据详情
        StockDetails.stockDetailPrint(this.$route.params.id).then(
            function (response) {
                if (response.data.status.isOK()) {
                    this.stock_detail = response.data.stock_detail;
                }
            }.bind(this)
        );
    },
};
</script>